import classNames from 'classnames/bind';
import React, { Ref } from 'react';
import { Link } from 'react-router';

import styles from './Button.module.scss';

export { default as FollowButton } from './Follow';
export { default as LikeButton } from './Like';

const cx = classNames.bind(styles);

/** @todo Could be much more type-safe. */
export interface ButtonProps {
  target?: string;
  disabled?: boolean;
  className?: string | null;
  to?: string;
  children: React.ReactNode;
  color?: 'blue' | 'flatBlue' | 'black' | 'red' | 'transparent';
  size?: 'tiny' | 'small' | 'medium';
  style?: React.CSSProperties;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  ref?: Ref<HTMLButtonElement | HTMLAnchorElement>;
  id?: string;
}

export const Button = ({
  className = null,
  to,
  children,
  color = 'blue',
  size = 'medium',
  disabled = false,
  ref,
  ...props
}: ButtonProps) => {
  const newClassName = cx(className, 'Button', {
    [`Button--${color}`]: color,
    [`Button--${size}`]: size,
    'Button--disabled': disabled,
  });

  const isLink = Boolean(to) && typeof to === 'string';
  const isExternal = to?.startsWith('http');

  if (isExternal) {
    return (
      <a
        href={to}
        className={newClassName}
        ref={ref as Ref<HTMLAnchorElement>}
        {...props}
      >
        {children}
      </a>
    );
  }

  if (isLink) {
    return (
      <Link
        to={to}
        className={newClassName}
        ref={ref as Ref<HTMLAnchorElement>}
        {...props}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={newClassName}
      ref={ref as Ref<HTMLButtonElement>}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
